// ロケーション情報
export class CustomLocationData {
    //public spaceID = 'mLyeJtCxq6Z';
    //
    public urlhead = 'https://my.matterport.com/show/';
    public addresses = [
        {place:'a', id:'NKFYiUgKLAU'},
        {place:'b', id:'KwNGUMJZwzu'},
        {place:'c', id:'CYXP4QibXmk'},
        {place:'z', id:'9AKugMMguHk'},
    ];
    public GetMPURL(place = 'a'){
        // MatterpoftスペースのURLを返す（クエリパラメータ ?m=XXXXX）
        var url = this.urlhead + '?m=';
        for(let elem of this.addresses){
            if(elem.place == place){
                return url + elem.id;
            }
        }
        return url + this.addresses[0].id;
    }
    public GetPlaceFromID(id){
        // MatterpoftスペースのIDから'place'（建物記号）を返す
        for(let elem of this.addresses){
            if(elem.id == id){
                return elem.place;
            }
        }
        return this.addresses[0].place;
    }
    public AddQueryParam(url, value = 'a10', name='loc', delim='?'){
        //URLにクエリパラメータlocを加える
        return url + delim + name + '=' + value;
    }

    public locationSets = {
        a: [ //A棟
            {name:'a00', sweepId:'6145396ff81741d6aba5975557bce6f3', rotation:{ x:  5.474 , y: -61.790  }},
            {name:'a10', sweepId:'6145396ff81741d6aba5975557bce6f3', rotation:{ x:  5.474 , y: -61.790  }},
            {name:'a21', sweepId:'6145396ff81741d6aba5975557bce6f3', rotation:{ x:  5.474 , y: -61.790  }},
            {name:'a22', sweepId:'88272da3d06c439d824f4764bbb02c5e', rotation:{ x:  5.243 , y: -55.349  }},
            {name:'a23', sweepId:'4d44d1b63ef4421596ba8dabb7465c84', rotation:{ x:  -1.782 , y: -38.984  }},
            {name:'a31', sweepId:'c84286484fc244c5a9a681538db163e0', rotation:{ x:  -0.650 , y: 167.967  }},
            {name:'a32', sweepId:'fcf65a1e790b4d1ea619eecd0a02f06e', rotation:{ x:  -7.658 , y: 33.570  }},
            {name:'a33', sweepId:'448558eeb96246c6be4d31aa11a7e073', rotation:{ x:  3.474 , y: 40.771  }},
            {name:'a34', sweepId:'6145396ff81741d6aba5975557bce6f3', rotation:{ x:  5.474 , y: -61.790  }},
            {name:'a41', sweepId:'baaecaae26ca4237a9982d6117edda46', rotation:{ x:  11.971 , y: -5.857  }},
            {name:'a42', sweepId:'7d5dcb3f9bcc46d6ac4365f8ab03160b', rotation:{ x:  -0.179 , y: -92.905  }},
        ],
        b:[ //B棟
            {name:'b00', sweepId:'673b1d13b4104e3085acf4f3dce9b62a', rotation:{ x:  -2.931 , y: -111.051  }},
            {name:'b11', sweepId:'6c75e6e252f24baa9856495dfa070c3c', rotation:{ x:  8.642 , y: -174.204  }},
            {name:'b12', sweepId:'8b15b3e24f1749dd9f27b09cf60ea246', rotation:{ x:  -10.417 , y: 64.978  }},
            {name:'b21', sweepId:'58fd97e351ee4f2eabafcd1d54c4f61d', rotation:{ x:  0.000 , y: -20.626  }},
            {name:'b22', sweepId:'e7c21c6842624efea2a42ba1f9fbe65e', rotation:{ x:  -24.731 , y: -60.369  }},
            {name:'b23', sweepId:'2fe2b55a55af4134841a29b3cf7d4585', rotation:{ x:  -15.620 , y: 35.289  }},
            {name:'b24', sweepId:'9dfe10a7d8034e48837d8a22fd23eb40', rotation:{ x:  -6.284 , y: -136.125  }},
            {name:'b31', sweepId:'ad69a55a67ac404db01d4ded270cc74e', rotation:{ x:  -33.199 , y: 30.599  }},
            {name:'b32', sweepId:'d0a51348f0b24e0b9280115d2bff3353', rotation:{ x:  -9.484 , y: -135.107  }},
            {name:'b33', sweepId:'689e22e1e71e4231b27750f753191329', rotation:{ x:  -15.832 , y: -9.532  }},
            {name:'b34', sweepId:'7351836dbfd244beb90593610a9fdc6b', rotation:{ x:  8.207 , y: 26.650  }},
        ],
        c:[ //C棟
            {name:'c00', sweepId:'df036e53a45849ba974d8871ad9dde89', rotation:{ x:  18.120 , y: -161.884  }},
            {name:'c10', sweepId:'fd7c8c6e810c43b19c0d5b673fc89d18', rotation:{ x:  -17.762 , y: 0.000  }},
            {name:'c20', sweepId:'658de4b133d047a5b22fd66b2d6d9799', rotation:{ x:  -7.527 , y: 43.438  }},
            {name:'c31', sweepId:'79ee5ba35e57426fa5a05180bb2fcfbf', rotation:{ x:  6.001 , y: 17.863  }},
            {name:'c32', sweepId:'00242feb3126408abe3bd6c7a087fed1', rotation:{ x:  -7.052 , y: 97.607  }},
            {name:'c41', sweepId:'19df342b2f2c49549f35eb2a3c1e7d97', rotation:{ x:  1.661 , y: 43.568  }},
            {name:'c51', sweepId:'cf14475c8de24e1495d6337440b19945', rotation:{ x:  -6.637 , y: 27.126  }},
            {name:'c52', sweepId:'c63c6ff17dc04573a52a701bd4984223', rotation:{ x:  9.130 , y: -5.223  }},
        ],
        z:[ //中庭
            {name:'z00', sweepId:'5e89e82df0f247fbbe7ef46621783dae', rotation:{ x:  10.982 , y: -77.491  }},
        ]
    };

    //タグID gr=0:3Dウォークスルー、1:3Dガイドツアー、2:謎解き
    public tagSets = {
        a: [
            { sid: "HbQZQjZGFyL", label: "フウリンブッソウゲ" },
        ],
    };

    public QueryTagIndex(type = 'a', sid = 'none'){
        //コンテンツタイプとSIDからインデックスを返す
        let data:{sid:string, label:string}[];
        if(type == 'a'){
            //3Dウォークスルー
            data = this.tagSets.a;
        }else{
            data = this.tagSets.a;
        }

        let index = -999;
        for(let i=0; i < data.length; i++){
            if (data[i].sid == sid){
                index = i;
                break;
            }
        }

        return index;
    }
}